import { useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtErr } from "../lib/api";
import { BookOpen } from "lucide-react";

export default function ForgotPassword() {
  const [step, setStep] = useState("request");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const inputCls = "mt-1 w-full bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 outline-none";

  const request = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setMsg("If that email exists, a reset token was sent. Enter it below with your new password.");
      setStep("reset");
    } catch (err) { setError(fmtErr(err)); }
  };

  const reset = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setMsg(data.message);
      setStep("done");
    } catch (err) { setError(fmtErr(err)); }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 font-bold text-xl font-heading text-neutral-900 mb-8">
          <BookOpen size={24} /> GloriPub
        </Link>
        <div className="bg-white border border-neutral-200 rounded-lg p-8 shadow-sm">
          <h1 className="text-2xl font-semibold font-heading text-neutral-900">Reset password</h1>
          {msg && <div data-testid="forgot-message" className="text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md p-3 text-sm my-4">{msg}</div>}
          {error && <div data-testid="forgot-error" className="text-red-700 bg-red-50 border border-red-200 rounded-md p-3 text-sm my-4">{error}</div>}
          {step === "request" && (
            <form onSubmit={request} className="space-y-4 mt-4">
              <div>
                <label className="text-sm font-medium text-neutral-700">Email</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
              </div>
              <button data-testid="forgot-submit-button" className="w-full py-2.5 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 font-medium text-sm">Send reset token</button>
            </form>
          )}
          {step === "reset" && (
            <form onSubmit={reset} className="space-y-4 mt-4">
              <div>
                <label className="text-sm font-medium text-neutral-700">Reset token</label>
                <input data-testid="reset-token-input" required value={token} onChange={(e) => setToken(e.target.value)} className={inputCls} />
              </div>
              <div>
                <label className="text-sm font-medium text-neutral-700">New password (min 8 characters)</label>
                <input data-testid="reset-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
              </div>
              <button data-testid="reset-submit-button" className="w-full py-2.5 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 font-medium text-sm">Reset password</button>
            </form>
          )}
          <p className="text-sm text-neutral-500 mt-5 text-center">
            <Link to="/login" className="text-neutral-900 font-medium hover:underline">Back to log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
